module.exports = __webpack_public_path__ + "img/tobeshipped.cf119c8c.png";